import * as React from 'react';

import FileKeynote16 from './FileKeynote16';

export const fileKeynote16 = () => <FileKeynote16 />;

export default {
    title: 'Icon|Fill|FileKeynote16',
    component: FileKeynote16,
    parameters: {
        notes: "`import FileKeynote16 from 'box-ui-elements/es/icon/fill/FileKeynote16';`",
    },
};
